import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {State} from '../../../reducers'
import { comprobanteRetencionClearAll } from '../../../actions/comprobante-retencion/comprobanteRetencionEmision.actions'
import { docsDatosReceptorReset } from '../../../actions/documentos/documentos.actions'

const CREEncabezado = (props: any) => {
  const dispatch = useDispatch()
  const facturaEmitida = useSelector((state: State) => state.comprobanteRetencion.facturaEmitda)

  const nuevaFactura = () => {
    if (facturaEmitida) {
      dispatch(comprobanteRetencionClearAll())
      dispatch(docsDatosReceptorReset())
    }
  }

  return (
    <>
      <div className='header-link'>
        <Link to={props.url} className='back-button w-inline-block' onClick={nuevaFactura}></Link>
        <h3 className='h3-titles xl'>Comprobante de Retención</h3>
      </div>
      <div className='separador'></div>
    </>
  )
}

export default CREEncabezado
